import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'atoms/Button/Button';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography from 'atoms/Typography/Typography';
import CheckItemTextListWithActions from 'molecules/CheckItemTextList/CheckItemTextListWithActions';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageAndContent from 'molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';

const SellingRightNowImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "11tPzJgqN8sUxwwLV86MJL" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1300)
      }
    }
  `);

  const renderItemContent = (boldText: string, regularText: string): JSX.Element => (
    <Stack
      direction='column'
      as='span'
    >
      <Typography
        as='span'
        fontWeight='font-weight-bold'
      >
        {boldText}
      </Typography>
      <Typography as='span'>{regularText}</Typography>
    </Stack>
  );

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'The $48 membership',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='left'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingText
              maxWidth='width-2xl'
              gap='spacing-3xl'
              heading={{
                type: 'heading',
                text: 'The $48 membership',
                size: 'xl',
                letterSpacing: -1,
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: "What's Selling Right Now",
                size: 'md',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              subHeadingGap='spacing-lg'
              supportingText={{
                type: 'paragraph',
                text: "This is what Mighty Hosts are selling—and why their members stay. We'll show you how to build it.",
                size: 'xl',
                color: 'text-tertiary',
              }}
            />
            <CheckItemTextListWithActions
              direction='column'
              justify='flex-start'
              align='flex-start'
              checkItemTextListProps={{
                checkItems: [
                  renderItemContent(
                    'Funnel',
                    'Challenges and mini-courses let prospective members get a taste of the membership.'
                  ),
                  renderItemContent(
                    'Membership',
                    'Monthly themes, weekly events, daily questions make up the core value of the membership.'
                  ),
                  renderItemContent(
                    'Bonuses',
                    'A bonus workshop, live event, or special challenge adds urgency and drives conversion.'
                  ),
                ],
                checkItemProps: {
                  size: 'md',
                  type: 'default',
                  color: 'primary',
                },
              }}
              actions={
                <Stack>
                  <Button
                    variant='primary'
                    size='xl'
                    href='https://cohost.mn.co/?plan=free-trial'
                  >
                    Try Mighty for Free
                  </Button>
                </Stack>
              }
            />
          </Stack>
        }
      />
    </Stack>
  );
};

export default SellingRightNowImageAndContent;
